import api from "./configuration";
import apiUrl from "./url";

const USE_AUTH_INTERCEPTOR = true;

export const MatchAPI = {
	list: async (filtersData) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Matches",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params: filtersData,
		});

		return response.data;
	},
	create: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Matches",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	getById: async (id, params) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Matches/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params,
		});

		return response.data;
	},
	delete: async (id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Matches/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	update: async (id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Matches/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	upload: async (id, file) => {
		const formData = new FormData();
		formData.append("file", file);

		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Matches/" + id + "/upload",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data: formData,
			headers: {"Content-Type": "multipart/form-data"},
		});

		return response.data;
	},
	createEvaluation: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Matches/evaluations",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	updateEvaluation: async (matchId, id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Matches/" + matchId + "/evaluations/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	deleteEvaluation: async (id, evaluationId) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Matches/" + id + "/evaluations/" + evaluationId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	createMeasurement: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Matches/rpe",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	createMeasurements: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Matches/multipleRpe",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	deleteMeasurement: async (id, evaluationId) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Matches/" + id + "/rpe/" + evaluationId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	updateMeasurement: async (matchId, id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Matches/" + matchId + "/rpe/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	createAttendance: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Matches/convocations",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	createMultipleAttendances: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Matches/multipleConvocations",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	deleteAttendance: async (id, attendanceId) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Matches/" + id + "/convocations/" + attendanceId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	updateAttendance: async (matchId, id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Matches/" + matchId + "/convocations/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	getPlayers: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Matches/" + id + "/players",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	addPlayers: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Matches/players",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	updatePlayer: async (matchId, id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Matches/" + matchId + "/players/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	deletePlayer: async (matchId, id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Matches/" + matchId + "/players/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	addEvents: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Matches/events",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	updateEvent: async (matchId, id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Matches/" + matchId + "/events/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	deleteEvent: async (matchId, id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Matches/" + matchId + "/events/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	getNotes: async (id, params) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Matches/" + id + "/notes",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params,
		});

		return response.data;
	},
	createNote: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Matches/notes",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	updateNote: async (matchId, id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Matches/" + matchId + "/notes/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	deleteNote: async (matchId, id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Matches/" + matchId + "/notes/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	getObservedPlayers: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Matches/" + id + "/playersObserved",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	createObservedPlayer: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Matches/playersObserved",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	deleteObservedPlayer: async (matchId, id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Matches/" + matchId + "/playersObserved/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	createAnalysis: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Matches/analysis",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	getAnalysisById: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Matches/" + id + "/analysis",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	deleteAnalysis: async (id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Matches/" + id + "/analysis",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	getAdvancedStats: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Matches/" + id + "/indexes",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	updateAdvancedStats: async (id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Matches/" + id + "/indexes",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	updateAnalysis: async (id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Matches/" + id + "/analysis",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
};
